
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { User, ShieldCheck, Heart, CalendarDays, Star, Leaf } from 'lucide-react';
import { Link } from 'react-router-dom';

interface WelcomePopupProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  username?: string;
}

const WelcomePopup: React.FC<WelcomePopupProps> = ({ 
  open = false, 
  onOpenChange,
  username = 'usuario'
}) => {
  const handleClose = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md max-w-xs p-4 rounded-lg">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-bold text-green-600">
            ¡Bienvenid@ a Guía Vegana, {username}!
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-3">
          <div className="flex justify-center mb-4">
            <img 
              src="/lovable-uploads/ae745547-332f-46cf-8369-8992e8b453d4.png" 
              alt="Lisa"
              className="w-20 h-20 rounded-full object-cover border-2 border-green-200"
            />
          </div>
          
          <p className="text-center text-sm text-gray-700 mb-3">
            Gracias por unirte a nuestra comunidad. Estamos aquí para ayudarte en tu camino vegano con:
          </p>
          
          <div className="grid grid-cols-3 gap-2 mt-2">
            <div className="bg-green-50 p-3 rounded-lg text-center">
              <User className="h-5 w-5 mx-auto text-green-600 mb-1" />
              <h3 className="text-xs font-medium text-green-700">Nutrición<br/>personalizada</h3>
            </div>
            
            <div className="bg-green-50 p-3 rounded-lg text-center">
              <CalendarDays className="h-5 w-5 mx-auto text-green-600 mb-1" />
              <h3 className="text-xs font-medium text-green-700">Menús<br/>semanales</h3>
            </div>
            
            <div className="bg-green-50 p-3 rounded-lg text-center">
              <ShieldCheck className="h-5 w-5 mx-auto text-green-600 mb-1" />
              <h3 className="text-xs font-medium text-green-700">Recetas<br/>deliciosas</h3>
            </div>
          </div>
          
          <div className="grid grid-cols-3 gap-2 mt-1">
            <div className="bg-green-50 p-3 rounded-lg text-center">
              <Heart className="h-5 w-5 mx-auto text-green-600 mb-1" />
              <h3 className="text-xs font-medium text-green-700">Comunidad<br/>vegana</h3>
            </div>
            
            <div className="bg-green-50 p-3 rounded-lg text-center">
              <Star className="h-5 w-5 mx-auto text-green-600 mb-1" />
              <h3 className="text-xs font-medium text-green-700">Retos<br/>divertidos</h3>
            </div>
            
            <div className="bg-green-50 p-3 rounded-lg text-center">
              <Leaf className="h-5 w-5 mx-auto text-green-600 mb-1" />
              <h3 className="text-xs font-medium text-green-700">Impacto<br/>positivo</h3>
            </div>
          </div>
        </div>
        
        <DialogFooter>
          <Button 
            onClick={handleClose}
            className="w-full bg-green-600 hover:bg-green-700 text-white"
          >
            ¡Empezar ahora!
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomePopup;
